<template>
  <div id="package-creation-forms">
    <item-tile
      v-for="(service, index) in subject.forms"
      :key="index"
      :heading="service.name"
      :selected="true"
      @click="removeForm(service)"
    />
    <item-tile
      v-for="(service, index) in forms"
      :key="index"
      :selected="false"
      :heading="service.name"
      @click="addForm(service)"
    />
  </div>
</template>
<script>
import ItemTile from "../../../../../../Components/UI/ItemTile.vue";
export default {
  data() {
    return {};
  },
  computed: {
    forms() {
      return this.$store.getters.forms.filter((x) => {
        return !this.subject.forms.includes(x);
      });
    },
  },
  methods: {
    addForm(service) {
      this.$emit("addForm", service);
    },
    removeForm(service) {
      this.$emit("removeForm", service);
    },
  },
  components: {
    ItemTile,
  },
  emits: ["addForm", "removeForm"],
  props: ["subject"],
};
</script>
<style scoped>
#package-creation-forms {
  display: flex;
  overflow: scroll;
  padding: 25px;
}
</style>
